import { render, staticRenderFns } from "./event-detail-status-sticky.vue?vue&type=template&id=4446fc73&scoped=true&"
import script from "./event-detail-status-sticky.vue?vue&type=script&lang=js&"
export * from "./event-detail-status-sticky.vue?vue&type=script&lang=js&"
import style0 from "./event-detail-status-sticky.vue?vue&type=style&index=0&id=4446fc73&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4446fc73",
  null
  
)

export default component.exports